import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { FetchOptions, isApiError } from "../../../types/api";
import { clientApi } from "@/lib/api/client";

export function useApiQuery<T extends object>(
  queryKey: readonly unknown[],
  path: string,
  options: FetchOptions = {},
  queryOptions: Omit<UseQueryOptions<T, Error>, "queryKey" | "queryFn"> = {}
) {
  return useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const response = await clientApi.get<T>(path, { ...options, signal });

      // Check if the response is an error using the type guard
      if (isApiError(response)) {
        throw new Error(response.error?.message || "API request failed");
      }

      // Return the full response object with type assertion
      return response as T;
    },
    ...queryOptions,
  });
}
